import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { WebHooksState } from '../WebHooksState';

export const makeClearRecentDeliveries =
  (updateState: DraftStateUpdater<WebHooksState>) => (): void => {
    updateState((draft) => {
      draft.recentDeliveries = null;
    });
  };
